import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router";
import { EpartsGroupPage } from "./group";
import { ResulteSearch } from "./sereach";
import { CampaignOrderPage } from "./campaignOrder";
import SparePartsCart from "./patsCart";
import CheckoutPage from "./partsCheckout";
import { CompaignDetails } from "./campaignDetails";
import { FeatureDetails } from "./featureDetails";
// import OfferPopupAds from "./pages/offers/offerPopupAds";
import { PartsHomePage } from "./partsHome";
import { EpartsDetailPage } from "./detail";
import CartIconWithPopover from "./components/CartPopoverContent"; // عدّل المسار حسب مكان الملف

export function EpartsPage() {
  const { t: trans, i18n } = useTranslation([`info`, `eparts`]);
  const { path } = useRouteMatch();
  let lang = i18n.language || "ar";
  var brand = 1;

  return (
    <>
      {/* <div className={"protection-and-shading   " + (brand == 1 ? " toyota-theme " : " lexus-theme ")}>
        <div className="protection-and-shading-head">
          <a href="/" className="protection-and-shading-head-Logo">
            {lang == "ar" ? (
              <div className="res-Logo-icon ">
                <img src="/assets/logo/logo_font_Black_AR.svg" alt="hassan jameel" className="hidden d-md-inline" />
                <img src="/assets/logo/logo_font_Black_AR.svg" alt="hassan jameel" className="d-inline d-md-hidden" />
              </div>
            ) : (
              <div className="res-Logo-icon ">
                <img src="/assets/logo/logo_font_Black_EN.svg" alt="hassan jameel" className="hidden d-md-inline" />
                <img src="/assets/logo/logo_font_Black_EN.svg" alt="hassan jameel" className="d-inline d-md-hidden" />
              </div>
            )}
          </a>

          <div className="protection-and-shading-head-extra flex flex-worp">
           
            <CartIconWithPopover
              linkToCart="/parts/cart"
            />


            <button
              onClick={() => {
                if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {
                  if (window.location.href.includes("/en")) window.location = window.location.href.replace("/en", "/ar");
                  if (window.location.href.includes("/ar")) window.location = window.location.href.replace("/ar", "/en");
                } else {
                  window.location = window.location.origin + "/en" + window.location.pathname;
                }
              }}
              className="protection-and-shading-top-lang h-full  flex justify-center items-center">
              <span className="text-white font-bold pl-2 pr-2 capitalize">{trans("common:changeLangCode")}</span>
              <img src="/assets/icons/globle.svg" alt="change language" />
            </button>
          </div>
        </div>
      </div> */}
      <Switch>
        <Route exact path={path} component={PartsHomePage} />

        <Route exact path={`${path}/detail`} component={EpartsDetailPage} />
        <Route exact path={`${path}/group/:GroupId`} component={EpartsGroupPage} />
        <Route exact path={`${path}/sereach`} component={ResulteSearch} />
        <Route exact path={`${path}/compaigndetails/:compaignId`} component={CompaignDetails} />
        <Route exact path={`${path}/featuredetails/:compaignId`} component={FeatureDetails} />
        <Route exact path={`${path}/detail/:ProductId`} component={EpartsDetailPage} />
        <Route exact path={`${path}/campaignorder`} component={CampaignOrderPage} />
        <Route exact path={`${path}/cart`} component={SparePartsCart} />
        <Route exact path={`${path}/checkout`} component={CheckoutPage} />
      </Switch>
    </>
  );
}
